/** @jsxImportSource theme-ui */
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { List } from 'semantic-ui-react';

import { FlexGroup } from 'components/_common/FlexGroup';
import { Typography } from 'components/_common/Typography';
import { IconButton } from 'components/_controls/IconButton';

import { openPanel } from 'diseaseActivityPanels/diseaseActivityPanels.saga';
import diseaseActivityPanelsSelectors from 'diseaseActivityPanels/diseaseActivityPanels.selectors';
import locationsSelectors from 'locations/locations.selectors';

import { deleteLocation } from '../locations.saga';
import { locationCardStyle } from './locations.styles';

type LocationCardProps = {
  geonameId: number;
};

const LocationCard: React.FC<LocationCardProps> = ({ geonameId }) => {
  const dispatch = useDispatch();
  const location = useSelector(locationsSelectors.getLocation(geonameId));
  const isDeleting = useSelector(locationsSelectors.getLocationIsDeleting(geonameId));
  const canDelete = useSelector(locationsSelectors.canDeleteLocations);
  const isSelected = useSelector(diseaseActivityPanelsSelectors.isLocationSelected(geonameId));

  return (
    location && (
      <List.Item
        data-testid="location-card"
        active={isSelected}
        sx={locationCardStyle}
        onClick={e => dispatch(openPanel({ panel: 'Diseases', geonameId: geonameId }))}
      >
        <FlexGroup
          alignItems="center"
          suffix={
            canDelete && (
              <IconButton
                ariaLabel="Close card"
                icon="icon-close"
                color="sea100"
                size="medium"
                onClick={e => {
                  e.stopPropagation();
                  dispatch(deleteLocation(geonameId));
                }}
                disabled={isDeleting}
              />
            )
          }
        >
          <Typography variant="subtitle2" color="stone90">
            {location.name}
          </Typography>
          <Typography variant="body2" color="deepSea50">
            {location.country}
          </Typography>
        </FlexGroup>
      </List.Item>
    )
  );
};

export default LocationCard;
